import angular = require("angular");
import {Config} from "../config";
import {SessionService} from "../services/session";
import {ConfirmController} from "../modals/confirm";
import {ChangePasswordController} from "../modals/changePassword";

import TPL = require("templates");


export class ProfileController {

  static $inject = ["$routeParams", "session", "$location", "$uibModal", "$timeout", "$log", "stripe", "Notification"];

  eventId;
  session: SessionService;
  location;
  timeout;
  modal;
  currentModal;
  log;
  showRegisterCard;
  showParam;
  cardList;
  cardSelected;
  cardData;

  stripe;
  notification;
  profile;
  randomColor;
  newCard;

  constructor($routeParams, session, $location, $modal, $timeout, $log, stripe, notification) {
    this.eventId = $routeParams.id;
    this.session = session;
    this.stripe = stripe;
    this.location = $location;
    this.modal = $modal;
    this.timeout = $timeout;
    this.notification = notification;
    this.log = $log;
    this.showParam = "show";
    this.showRegisterCard = false;
    this.cardList = [];

    this.clearProfile();
    this.getCardsList();
    this.cardSelected = "";
    this.newCard = true;
    this.randomColor = this.getRandomColor();

    this.log.debug(this.profile.birthDate);
  }

  clearProfile() {

    this.profile = {
      firstName: this.session.getFirstName(),
      lastName: this.session.getLastName(),
      email: this.session.getEmail(),
      birthDate: this.session.getBirthDate(),
      city: this.session.getCity(),
      city_state: this.session.getCityState(),
      address: this.session.getAddress(),
      address_secondary: this.session.getAddressSecondary(),
      phone: this.session.getPhone(),
      bio: this.session.getBio()
    }
  }

  uploadNewAvatar(file) {

    this.session.uploadFile(file).then((url) => {
      return this.session.updateProfile({
        avatar: url
      }).then(() => {
        //This is a trick to make the avatar update itself.
        //TODO remove as it is shameful polling!!
        //TODO 2 what happens if avatar upload fails??

        var recursiveRefresh = () => {
          this.session.refreshProfile().then(() => {
            if (!this.session.getAvatar()) {
              this.timeout(recursiveRefresh, 2000);
            }
          });
        }

        //i start polling delayed here because the profile is already automatically refreshed after the update
        this.timeout(recursiveRefresh, 2000);

      });
    });
  }

  getAvatarStyle(shadow) : any {
    if (!this.session.getAvatar()) {
      return {'background': this.randomColor};
    }

    if (shadow) {
      return {'background-image': 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(' + this.session.getAvatar() + ')'};
    } else {
      return {'background-image': 'url(' + this.session.getAvatar() + ')'};
    }
  }

  getCurrentFullName() {
    return (this.profile.firstName || "") + " " + (this.profile.lastName || "");
  }

  getCurrentInitials() {
    if (!this.session.getAvatar()) {
      if (this.profile.firstName != null && this.profile.lastName != null) {
          return (this.profile.firstName.charAt(0) || "") + " " + (this.profile.lastName.charAt(0) || "");
      } else {
          return "";
      }
    } else {
      return "";
    }
  }

  goLanding() {
    this.location.url(Config.home);
  }

  openChangePasswordModal() {
    this.currentModal = ChangePasswordController.openChangePasswordModal(this.modal, this, this.session, this.location);
  }

  submit(form) {
    if (form.$valid) {

      var modal = this.modal.open({
        controller: () => new ConfirmController(this, {
          title: "PROFILE.CONFIRM_TITLE",
          title2: "PROFILE.CONFIRM_SUBTITLE",
          logo: false,
          actions: [
            {
              label: "PROFILE.CONFIRM_SUBMIT",
              primary: true,
              callback: ()=>{
                this.session.updateProfile(this.profile).then((response) => {
                  this.clearProfile();
                  modal.dismiss();
                });
              }
            },
            {
              label: "PROFILE.CONFIRM_CANCEL",
              primary: false,
              callback: ()=>{
                this.clearProfile();
                modal.dismiss();
              }
            },
          ]
        }),
        controllerAs: "vm",
        replace: true,
        size: "sm",
        template: TPL.modals.confirm
      });
    }
  }

  registerCard(form,param) {

      var cardData = {
        number: this.cardSelected.number,
        name: this.cardSelected.owner,
        cvc: this.cardSelected.cvv,
        exp_month: this.cardSelected.expiration_month,
        exp_year: this.cardSelected.expiration_year
      };

      var data;
      if (!this.newCard) {
        data = {
          id: this.cardSelected.id,
          favourite: this.cardSelected.favourite
        };
        return this.session.changeCard(data,param).then((response) => {
            this.getCardsList();
            this.cardSelected = "";
            this.newCard = true;
            this.openRegisterCard('hide');
        });
      } else {
        this.stripe.card.createToken(cardData)
          .then((response) => {
            data = {
              stripe_token: response.id,
              favourite: this.cardSelected.favourite
            };

            return this.session.registerNewCard(data).then((response) => {
                this.getCardsList();
                this.openRegisterCard('hide');
                this.notification.success("Registration of card has been completed!");
            });
          })
          .catch((err) => {
            this.notification.error("Register card error!");

            if (err.type && /^Stripe/.test(err.type)) {
              this.log.debug('Stripe error: ', err.message);
            }
            else {
              this.log.debug('Other error occurred, possibly with your API', err.message);
            }
            throw err;
          });
      }

      /*this.stripe.card.createToken(cardData)
        .then((response) => {
          if (!this.newCard) {
            data = {
              id: this.cardSelected.id,
              favourite: this.cardSelected.favourite
            };
          } else {
            data = {
              stripe_token: "",
              favourite: ""
            };

            data.stripe_token = response.id;
            data.favourite = this.cardSelected.favourite;
          }


          if (param !== "newcard") {
            return this.session.changeCard(data,param).then((response) => {
                this.getCardsList();
                this.openRegisterCard('hide');
            });
          } else {
            return this.session.registerNewCard(data).then((response) => {
              this.log.debug("eccoci");
                this.log.debug(response);
                this.getCardsList();
                this.openRegisterCard('hide');
            });
          }
        })
        .then((payment) => {
          this.log.debug('successfully register card');

        })
        .catch((err) => {
          if (err.type && /^Stripe/.test(err.type)) {
            this.log.debug('Stripe error: ', err.message);
          }
          else {
            this.log.debug('Other error occurred, possibly with your API', err.message);
          }
          throw err;
        });*/

  }

  getRandomColor() {
    var colors = ["#8D1B3D", "#443135", "#857363", "#50C9B5", "#FCD450"];
    var randomIndex = Math.floor(Math.random() * colors.length);
    this.log.debug(randomIndex);
    return colors[randomIndex];
  }

  openRegisterCard(param,cardId?) {
    if (param === "show"){
      this.showRegisterCard = true;
      this.showParam = "hide";
    } else {
      this.showRegisterCard = false;
      this.showParam = "show";
    }
    if (cardId){
      this.getCard(cardId);
    } else {
      this.cardSelected = null;
    }
  }

  getCardsList() {
    this.session.getCardList().then(
      (response) => {
        this.cardList = response;
    });
    this.log.debug("cards-list");
    this.log.debug(this.cardList);

  }

  getCard(cardId){
    this.session.getCardSelected(cardId).then(
      (response) => {
        var expiration = response.expiration.split("/")
        this.cardSelected = {
          id: response.id,
          number: "**** **** **** " + response.number,
          expiration_month: expiration[0],
          expiration_year: expiration[1],
          brand: response.brand,
          favourite: response.favourite,
          owner: response.owner,
          cvv: "***"
        }
        this.newCard = false;
    });
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/profile.ts
 **/